/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router";
import Paper from "@mui/material/Paper";
import TextContainer from "../../Container/TextContainer";
import PersonalDataSummary from "./Summary/PersonalDataSummary";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import IncomeSummary from "./Summary/IncomeSummary";
import AssetsSummary from "./Summary/AssetsSummary";
import CostsSummary from "./Summary/CostSummary";
import { getCaseLink } from "../../../services/productService";
import { useForm } from "../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

type SummaryProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function Summary({ product, submitProps }: SummaryProps) {
  const location = useLocation();
  const stateField = location.state?.field;
  const { values, handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <>
      <Paper elevation={4}>
        <TextContainer>
          <Typography variant={"h4"} sx={summaryStyle.headline}>
            Ihre Angaben
          </Typography>
          <Grid container>
            <Box id={"personalDataSummary"} sx={summaryStyle.scrollToAnchor} />
            <PersonalDataSummary formData={values} />
          </Grid>
          <Grid container>
            <Box id={"incomeSummary"} sx={summaryStyle.scrollToAnchor} />
            <IncomeSummary formData={values} />
          </Grid>
          <Grid container>
            <Box id={"assetsSummary"} sx={summaryStyle.scrollToAnchor} />
            <AssetsSummary formData={values} />
          </Grid>
          <Grid container>
            <Box id={"costsSummary"} sx={summaryStyle.scrollToAnchor} />
            <CostsSummary formData={values} />
          </Grid>

          <form onSubmit={handleSubmit}>
            <FormSubmit
              {...submitProps}
              hideBackButton={false}
              backLink={getCaseLink(product) + "/antrag/assistent"}
              backText={"Alles bearbeiten"}
              nextText={"Angaben speichern"}
              nextButtonSubtext={
                <small>
                  <LockIcon sx={{ height: "12px", width: "12px", paddingTop: "2px" }} /> SSL-zertifiziert - Wir schützen Ihre Daten!
                </small>
              }
            />
          </form>
        </TextContainer>
      </Paper>
    </>
  );
}
